import React from 'react';
import { useState } from 'react';
import './Month.css';

// month:       0 - 11  :  Jan - Dec
// monthTexts:  translate string array for month names. like ['January', 'Feburay', ....]
// activeDats:  {'2025-01-30': 1, '2025-02-20': 1}
function Month({
    year, 
    month,
    monthTexts,
    weekDayTexts,
    activeDates,
    onDatePicked,
    selectedDate,
    selectedDateBackgroundColor,
    selectedDateColor,
    startDate,
    endDate,
    activeStartDate,
    activeEndDate
}) {
    monthTexts = monthTexts || ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    weekDayTexts = weekDayTexts || ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    //result[0].getDate();        1    ,  the first day
    //result[0].getDay();         0 - 6,  Sunday - Saturday
    function getDaysInMonth(month, year) {
        let date = new Date(year, month, 1);
        let days = [];
        while (date.getMonth() === month) {
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        return days;
    }

    let days = getDaysInMonth(month, year);
    let firstDay = days[0].getDay();                    // 
    let lastDay = days[days.length-1].getDay();
    let daysPerWeek = 7;
    let maxDayIndex = daysPerWeek - 1;

    let dateNumbersWithPadding = [];
    if (firstDay != 0) {
        for(let i = 0; i < firstDay; i++){
            dateNumbersWithPadding.push(0);
        }
    }
    for(let v of days) {
        dateNumbersWithPadding.push(v.getDate());
    }
    if (lastDay != maxDayIndex){
        for (let i = 0; i < maxDayIndex - lastDay; i++) {
            dateNumbersWithPadding.push(0);
        }
    }

    let groupedDateNumbers = [];
    for (let k in dateNumbersWithPadding){
        let g = Math.floor(k / daysPerWeek);
        if (groupedDateNumbers[g] == undefined) {
            groupedDateNumbers[g] = [dateNumbersWithPadding[k]];
            
        } else {
            groupedDateNumbers[g].push(dateNumbersWithPadding[k]);
        }
    }

    function _pad0(n) {
        n = n + '';
        return n.padStart(2, '0');
    }

    // return string like '2025-01-01', month starts with 0(Jan).  dateNumber starts with 1
    function getDateString(year, month, dateNumber) {
        return  dateNumber ? (year + '-' + _pad0(month+1)  + '-' + _pad0(dateNumber)) : '';
    }

    function isActive(year, month, dateNumber) {
        let d = getDateString(year, month, dateNumber);
        if (activeDates && activeDates.any) {
            let ds = new Date(activeStartDate || startDate);
            let de = new Date(activeEndDate   || endDate);
            let dn = new Date(d);
            return (dn >= ds && dn <= de);
        } else {
            return (activeDates != undefined && activeDates[d] != undefined);
        }
    }

    function getActiveCss(year, month, dateNumber) {
        if (isActive(year, month, dateNumber)) {
            return 'active ' + SG.BD_PRIMARY;
        }
        return '';
    }

    function getSelectedCss(year, month, dateNumber) {
        let d = getDateString(year, month, dateNumber);
        if (d == selectedDate) {
            return 'selected';
        }
        return '';
    }

    function dateCellClicked(e) {
        if (e.target.classList.contains('active')) {
            let d = e.target.dataset.date;
            if (d) {
                onDatePicked(d);
            }
        }
    }

    // WCAG 2.1.1 (Keyboard): allow arrow-key navigation across calendar days.
    //   Left  / Right : previous / next available day
    //   Up    / Down  : same weekday in previous / next week (nearest available day)
    //   Home  / End   : first / last available day of the current week
    //   Enter / Space : select the focused day
    // Focus only moves to selectable (".active") cells; non-available and padding cells are skipped.
    function dateCellKeyDown(e) {
        // Gate behind the WCAG-accessibility feature flag (mirrored to the
        // <html class="WCAG-accessibility"> by GF::documentClass()).
        if (typeof document === 'undefined' ||
            !document.documentElement ||
            !document.documentElement.classList ||
            !document.documentElement.classList.contains('WCAG-accessibility')) {
            return;
        }
        const key = e.key;
        const isArrow = key === 'ArrowLeft' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowDown';
        const isHomeEnd = key === 'Home' || key === 'End';
        const isActivate = key === 'Enter' || key === ' ' || key === 'Spacebar';
        if (!isArrow && !isHomeEnd && !isActivate) return;
        const cur = e.currentTarget;
        if (isActivate) {
            if (cur.classList.contains('active')) {
                e.preventDefault();
                cur.click();
            }
            return;
        }
        e.preventDefault();
        const tr = cur.closest('tr');
        const table = cur.closest('table');
        if (!tr || !table) return;
        const activeSel = 'button.rtp_date_cell.active';
        let target = null;
        if (key === 'ArrowLeft' || key === 'ArrowRight') {
            const cells = table.querySelectorAll(activeSel);
            const idx = Array.prototype.indexOf.call(cells, cur);
            const nextIdx = (key === 'ArrowRight') ? idx + 1 : idx - 1;
            if (nextIdx >= 0 && nextIdx < cells.length) target = cells[nextIdx];
        } else if (key === 'Home' || key === 'End') {
            const inRow = tr.querySelectorAll(activeSel);
            if (inRow.length) target = (key === 'Home') ? inRow[0] : inRow[inRow.length - 1];
        } else { // ArrowUp / ArrowDown -- try same column first, then nearest active in that row
            const cellsInRow = tr.querySelectorAll('button.rtp_date_cell');
            const col = Array.prototype.indexOf.call(cellsInRow, cur);
            let row = (key === 'ArrowDown') ? tr.nextElementSibling : tr.previousElementSibling;
            while (row) {
                const candidates = row.querySelectorAll('button.rtp_date_cell');
                const sameCol = candidates[col];
                if (sameCol && sameCol.classList.contains('active')) {
                    target = sameCol;
                    break;
                }
                row = (key === 'ArrowDown') ? row.nextElementSibling : row.previousElementSibling;
            }
        }
        if (target) target.focus();
    }

    return (
        <div className={`month_ra_container ${SG.RC_BD_RADIUS} ${SG.BG_3}`} style={{boderRadius: '8px'}}>
            <div className={`title_row ${SG.F_BODY}`}>
                <span className={`${SG.F_BODY}`}>{monthTexts[month]}</span>
                <span className={`${SG.F_BODY}`}>{year}</span>
            </div>
            <table>
                <thead>
                    <tr className={`${SG.F_HEADER_S}`}>
                        {weekDayTexts.map((weekDayText, index) => <td key={index}>{weekDayText}</td> )}
                    </tr>
                </thead>
                <tbody>
                    {
                        groupedDateNumbers.map((weekdate, weekIndex) => { return(
                            <tr key={weekIndex}>
                                { 
                                    weekdate.map((dateNumber, dateIndex) => { return(
                                        <td key={dateIndex}>
                                            <button type="button"
                                                className={'clean_button rtp_date_cell ' + (dateNumber ? 'not_empty' : 'empty') + ' ' + getActiveCss(year, month, dateNumber) + ' ' + getSelectedCss(year, month, dateNumber)} 
                                                data-date={ getDateString(year, month, dateNumber)}  onClick={dateCellClicked} 
                                                onKeyDown={dateCellKeyDown}
                                                tabIndex={getActiveCss(year, month, dateNumber) ? '0' : '-1'}
                                                style={ getSelectedCss(year, month, dateNumber) ? {backgroundColor:selectedDateBackgroundColor, color:selectedDateColor, borderColor:selectedDateBackgroundColor} : {borderColor:selectedDateBackgroundColor}}
                                                aria-label ={getDateString(year, month, dateNumber)}
                                            >
                                                {dateNumber ? dateNumber : ''}
                                            </button>
                                        
                                        </td>
                                    )})
                                }
                            </tr>
                        )})
                    }
                </tbody>
            </table>
        </div>
    )
}

export default Month;
